import { Link } from "react-router-dom";

/**
 * Rodape legal. Fica em componente porque as paginas publicas mostram a
 * mesma coisa, e um CNPJ ou um email de suporte divergente entre elas seria
 * pior que nenhum.
 */
const CNPJ = "40.838.857/0001-08";
// Endereco fisico exigido pelo Decreto 7.962/2013 (comercio eletronico).
const ENDERECO = "Rua Parnaíba, 585, Minaslândia, Belo Horizonte/MG, CEP 31812-280";
const SUPORTE = "suporte@alugando.com";

export function RodapeLegal({ soCreditos = false }: { soCreditos?: boolean }) {
  return (
    <div className="rodape-legal">
      {!soCreditos && (
        <p>
          <a href="/manual/">Manual</a> ·{" "}
          <Link to="/termos">Termos de uso</Link> ·{" "}
          <Link to="/privacidade">Privacidade</Link> ·{" "}
          Suporte: <a href={`mailto:${SUPORTE}`}>{SUPORTE}</a>
        </p>
      )}
      <p>
        © {new Date().getFullYear()} alugando.com · CNPJ {CNPJ} · {ENDERECO}
      </p>
    </div>
  );
}
